module.exports = __webpack_public_path__ + "static/media/slider-l5-768.3338998f.webp";